<template>
  <v-app data-app id="app" class="vh-100">
    <Loader :visible="loading" />
    <div class="" v-if="!isLoginView">
      <HeaderComponent></HeaderComponent>
    </div>
    <div style="height: calc(100vh - 75px);">
      <SideMenuComponent v-if="!isLoginView" :menuRights="menuRights" />
      <router-view />
    </div>
    <div class="left-bottom">© 2023 Powered by BEX @1.1.0</div>
  </v-app>
</template>

<script>
import HeaderComponent from "@/components/Layout/HeaderComponent.vue";
import SideMenuComponent from "@/components/Layout/SideMenuComponent.vue";
import Loader from "@/components/Loader.vue";
import { mapState } from "vuex";
import StoreGetter from "@/constants/StoreGetter";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    Loader,
    HeaderComponent,
    SideMenuComponent
  },
  computed: {
    ...mapState("LoaderStore", {
      loading: "loading"
    }),
    isLoginView() {
      const routesThatHideHeaderAndNav = [
        "Login",
        "404",
        "Verify",
        "JobApplication",
        "CandidateJobApplicationForm",
        "CandidateJobInterviewStart"
      ];

      if (this.$route.name) {
        return routesThatHideHeaderAndNav.indexOf(this.$route.name) > -1;
      } else {
        return true;
      }
    },
    menuRights() {
      const menuRights = { allRights: {}, rightsForThisMenu: {} };
      menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      menuRights.rightsForThisMenu = menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
      return menuRights;
    }
  },
  methods: {},

  mounted() {}
};
</script>
<style scoped>
.left-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  color: #ffffff;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue